export default __webpack_public_path__ + "static/media/single-project-page-02-img8.3b1a219e.jpg";